import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import styles from "./Leaderboard.module.scss";

const DEFAULT_SHOW = 10;
const EXPANDED_SHOW = 15;

const formatValue = (num) => {
  if (num >= 1e6) return (num / 1e6).toFixed(1) + "M";
  if (num >= 1e3) return Math.round(num / 1e3).toLocaleString() + "K";
  return num.toLocaleString();
};

const capitalize = (str) =>
  str.replace(/\b\w/g, (c) => c.toUpperCase());

const Leaderboard = ({
  title,
  description,
  data,
  nameKey,
  valueKey,
  variant = "institution",
}) => {
  const [expanded, setExpanded] = useState(false);
  const limit = expanded ? EXPANDED_SHOW : DEFAULT_SHOW;
  const visibleData = data.slice(0, limit);
  const canExpand = data.length > DEFAULT_SHOW;

  const chartData = visibleData.map((item) => ({
    ...item,
    displayName:
      variant === "keyword" ? capitalize(item[nameKey]) : item[nameKey],
  }));

  const chartHeight = Math.max(chartData.length * 52, 200);

  return (
    <div className={styles["leaderboard"]}>
      <h3 className={styles["leaderboard__title"]}>{title}</h3>
      {description && (
        <p className={styles["leaderboard__description"]}>{description}</p>
      )}

      <div className={styles["leaderboard__chart"]}>
        <ResponsiveContainer width="100%" height={chartHeight}>
          <BarChart
            data={chartData}
            layout="vertical"
            margin={{ top: 0, right: 60, left: 10, bottom: 0 }}
          >
            <XAxis type="number" hide />
            <YAxis
              type="category"
              dataKey="displayName"
              width={200}
              tick={{ fontSize: 13, fill: "var(--text-1)" }}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip
              formatter={(value) => [formatValue(value), "Publications"]}
              contentStyle={{
                borderRadius: 8,
                border: "1px solid rgba(0,0,0,0.08)",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            />
            <Bar
              dataKey={valueKey}
              radius={[0, 6, 6, 0]}
              barSize={28}
              fill={"#0f3460"}
              label={{
                position: "right",
                formatter: formatValue,
                fontSize: 12,
                fontWeight: 600,
                fill: "var(--text-1)",
              }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

        {/* {canExpand && (
        <button
          className={styles["leaderboard__toggle"]}
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? "SHOW LESS" : "SHOW MORE"}{" "}
          <span className={styles["leaderboard__toggle-arrow"]}>
            {expanded ? "▲" : "▼"}
          </span>
        </button> */}
      <button
        className={styles["leaderboard__toggle"]}
      >
        {variant == "keyword" ? "Millions of Topics coming soon" : "All US Institutions coming soon"}{" "}
      </button>
    </div>
  );
};

export default Leaderboard;
